import React from 'react';
import JobForm from '../components/JobForm';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';

const EditPage = () => {
  return (
    <>
      <Navbar />
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
        <Sidebar />
        <div className="lg:pl-[14rem]  mt-[5.8125rem]">
          <JobForm />
        </div>
      </div>
    </>
  );
};

export default EditPage;
